import { transitGroupsListWithPaging } from '@/services/api-transit/transitGroups';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.TransitGroup[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);
  const fetch = async () => {
    const res = await transitGroupsListWithPaging({
      pageSize: -1,
      filter: JSON.stringify({}),
    });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.TransitGroup) => ({
          ...pre,
          [curr.id]: curr.name,
        }),
        {},
      ),
    );
    setValueOptions(
      res.data?.map((item: API.TransitGroup) => ({ value: item.id, label: item.name })),
    );
  };
  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
